var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskNiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 176,
    viewBox: "0 0 600 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_1626)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -5,
    width: 600,
    height: 210,
    fill: "url(#paint0_linear_77_1626)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M716 88.5C614.63 88.5 599.5 103.5 599.5 204C599.5 103.5 584.37 88.5 483 88.5C584.37 88.5 599.5 73.4998 599.5 -27C599.5 73.4998 614.63 88.5 716 88.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_b_77_1626)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.646 313.744L-1 145.563V449.521L49.2384 496.553C106.844 550.482 201.106 550.482 258.712 496.553L601 176.109V114.449L388.119 313.744C330.514 367.673 236.251 367.673 178.646 313.744Z",
    fill: "white",
    fillOpacity: 0.09
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1 38.2004L146.872 176.637C204.479 230.566 298.74 230.566 356.347 176.637L601 -52.4024V-296.87L557.23 -255.893L258.712 23.5741C201.105 77.5033 106.844 77.5033 49.2384 23.5741L-1 -23.4582V38.2004Z",
    fill: "#1F5593",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13,
    filter: "url(#filter1_b_77_1626)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2384 23.5742C106.844 77.5034 201.106 77.5034 258.712 23.5742L557.23 -255.893L601 -296.87V-393H574.276L492.527 -316.468L307.53 -143.278C249.924 -89.3492 155.661 -89.3492 98.0561 -143.278L-1 -236.012V-23.4581L49.2384 23.5742Z",
    fill: "#00AEEF",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_77_1626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.239 89.6327C309.395 89.6327 299.12 99.8104 299.12 168C299.12 99.8104 288.844 89.6327 220 89.6327C288.844 89.6327 299.12 79.455 299.12 11.2653C299.12 79.455 309.395 89.6327 378.239 89.6327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 39.6484C351.197 39.6484 347.048 43.7577 347.048 71.2968C347.048 43.7577 342.899 39.6484 315.096 39.6484C342.899 39.6484 347.048 35.5391 347.048 8.00006C347.048 35.5391 351.197 39.6484 379 39.6484Z",
    fill: "url(#paint1_linear_77_1626)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M116 88.5C14.6301 88.5 -0.499997 103.5 -0.499992 204C-0.499997 103.5 -15.6301 88.5 -117 88.5C-15.6301 88.5 -0.499998 73.4998 -0.500002 -27C-0.499998 73.4998 14.6301 88.5 116 88.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_77_1626",
    x: -370.4,
    y: -254.951,
    width: 1340.8,
    height: 1161.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 184.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_77_1626",
    x: -185.1,
    y: -577.1,
    width: 970.2,
    height: 825.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 92.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_1626",
    x1: 0,
    y1: -5,
    x2: 125.529,
    y2: 355.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0191D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#264480"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_1626",
    x1: 315.096,
    y1: 71.2968,
    x2: 376.201,
    y2: 9.85076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA7B23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_1626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 176,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_77_1626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 159,
    fill: "white",
    transform: "translate(220 168) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskNiki);
export default __webpack_public_path__ + "static/media/askNiki.53756a73b20b5d724508c83974a8e6e3.svg";
export { ForwardRef as ReactComponent };